// src/components/Header.js
import React, { useEffect, useState } from 'react';
import { useNavigate, NavLink,useLocation } from 'react-router-dom';
import './HeaderFooter.css';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import logo from '../assets/logo.png';
import { useWarning } from '../Utils/WarningContext';

const Header = () => {
  
  const navigate = useNavigate();
  const employeeName = localStorage.getItem('username') || "User";
  const { warningMessage } = useWarning();

  const handleLogout = () => {
    // Clear auth/token or perform logout logic here
    localStorage.clear();
    navigate('/login');
  };

  return (
    <>
    <Navbar expand="md" className="custom-header" variant="dark">
      <Container fluid>
        {/* Logo and Brand with Home link and icon */}
        <Navbar.Brand className="text-white d-flex align-items-center">
          <NavLink to="/home" className="text-white d-flex align-items-center text-decoration-none">
            {/* <i className="fas fa-home me-2 fs-4 text-white"></i> */}
            <span className="fw-bold"><img src={logo} alt="Logo" className='logo-img' /></span>
          </NavLink>
        </Navbar.Brand>

        {/* Navbar Toggler for mobile */}
        <Navbar.Toggle aria-controls="navbar-nav" className="border-0" />
        <Navbar.Collapse id="navbar-nav">
          <Nav className="me-auto ms-3">
            {/* Home link */}
            <NavLink to="/home" className="nav-link text-white">
              <i className="fas fa-home me-1"></i> Home
            </NavLink>
            {/* Create Request link */}
            <NavLink to="/create-request" className="nav-link text-white">
              <i className="fas fa-file-alt me-1"></i> Request for Approval
            </NavLink>

            {/* Reports link with hover effect */}
            <Nav.Item className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle text-white"
                href="#"
                id="reportsDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fas fa-chart-bar me-1"></i> Reports
              </a>
              <ul className="dropdown-menu shadow-sm rounded" aria-labelledby="reportsDropdown">
                <li>
                  <NavLink
                    to="/status-report"
                    className={({ isActive }) =>
                      `dropdown-item d-flex align-items-center ${isActive ? "active" : ""}`
                    }
                  >
                    <i className="fas fa-file-alt me-2"></i> Status Report
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/tat-report"
                    className={({ isActive }) =>
                      `dropdown-item d-flex align-items-center ${isActive ? "active" : ""}`
                    }
                  >
                    <i className="fas fa-clock me-2"></i> TAT Report
                  </NavLink>
                </li>
                {/* <li>
                  <NavLink
                    to="/smart-report"
                    className={({ isActive }) =>
                      `dropdown-item d-flex align-items-center ${isActive ? "active" : ""}`
                    }
                  >
                    <i className="fas fa-clock me-2"></i> Smart Report
                  </NavLink>
                </li> */}
              </ul>
            </Nav.Item>



          </Nav>

          {/* User and Logout */}
          <div className="d-flex align-items-center text-white">
            <span className="me-3 d-none d-sm-inline">
              {/* <i className="fas fa-user-circle me-2"></i>  */}
              Welcome to GENAPP, {employeeName}
            </span>
            <Button className="btn btn-sm custom-logout-btn" onClick={handleLogout}>
              <i className="fas fa-sign-out-alt me-1"></i> Logout
            </Button>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
   
    {warningMessage && (
        <div className="bg-danger text-white py-1 px-3">
          <marquee behavior="scroll" direction="left">
            <strong>🔔 Notice:{warningMessage}</strong>
          </marquee>
        </div>
      )}
      </>
  );
};

export default Header;
